import { Link, useLocation } from "react-router-dom";
import { ArrowLeftRight, Gamepad2, User } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Transaction", icon: ArrowLeftRight },
  { to: "/jeux", label: "Jeux", icon: Gamepad2 },
  { to: "/account", label: "Compte", icon: User },
] as const;

export function BottomNav({ accent = "var(--accent-brand)" }: { accent?: string }) {
  const { pathname } = useLocation();
  return (
    <nav
      className="sticky bottom-0 z-30 shrink-0 border-t border-border bg-header-bg backdrop-blur-xl [padding-bottom:env(safe-area-inset-bottom)]"
      aria-label="Navigation principale"
    >
      <ul className="mx-auto flex max-w-[52ch] items-stretch justify-around px-2 py-1.5 lg:max-w-6xl">
        {ITEMS.map(({ to, label, icon: Icon }) => {
          const active = pathname === to;
          return (
            <li key={to} className="flex-1">
              <Link
                to={to}
                className="flex flex-col items-center justify-center gap-0.5 rounded-lg px-1 py-1.5 transition"
                style={active ? { color: accent } : { color: "var(--muted-foreground)" }}
              >
                <Icon className="size-5" strokeWidth={active ? 2.4 : 1.8} />
                <span className="text-[10px] font-semibold tracking-wide">{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}